<script lang="ts" setup>
import BaseCard from "@/components/BaseCard.vue";
import SkillOrb from "@/components/SkillOrb.vue";
import { SkillOrb as SkillOrbType } from "@/types/hidden-potential";
import { ref } from "vue";

defineProps<{
  skillOrbs: SkillOrbType[];
}>();

const scale = ref(0.67);
</script>

<template>
  <BaseCard>
    <template #heading>Exclusive Skill Orbs</template>

    <div
      :style="`grid-template-columns: repeat(auto-fit,${scale * 100}px)`"
      class="grid w-full place-content-around gap-4"
    >
      <SkillOrb
        v-for="skillOrb in skillOrbs"
        :key="skillOrb.id"
        :scale="scale"
        :skill-orb="skillOrb"
        clickable
      />
    </div>
  </BaseCard>
</template>

<style scoped></style>
